import Dropdown from 'react-bootstrap/Dropdown';
import Badge from 'react-bootstrap/Badge';
import React, {useState} from 'react';

export default function PillTableCell({id, className, children, selectList, onSelect, onUnSelect,menuOpen,onMenuChange, rowData}) {
    const [selectMode, setSelectMode] = useState(false);
    const assignedUsers = rowData?.assigned_user_ids
        ? rowData.assigned_user_ids.split(',').map(id => id.trim())
        : [];
    const selectedUsers = assignedUsers.map(id => selectList[id]).filter(user => !!user);
    // Filtere nur Inhalte, die sinnvoll sind (nicht leer, keine Leerzeichen, kein null/undefined)
    const validChildren = React.Children.toArray(children).filter(
        (child) => typeof child === "string" && child.trim() !== "" // prüft auf Strings ohne Leerzeichen
    );

    const onSelectClick = (e) => {
        e.preventDefault();
        setSelectMode(true);
    };

    const UserPillElement = React.forwardRef(({ users = [], onClick,onUnselect }, ref) => {
        if (users.length > 0) {
            return (
                <>
                    {users.map((user, index) => (
                        <Badge
                            key={index}
                            ref={ref}
                            pill
                            bg={"none"}
                            className={"cursor-pointer assigned-user-pill"}
                            style={{ backgroundColor: user.color ?? 'grey' }}
                            onClick={(e) => {
                                e.preventDefault();
                                onClick(user, e); // Übergibt den konkreten Benutzer
                            }}
                        >
                            {user.preview_image && (
                                <img
                                    className={'pill-user-image'}
                                    src={user.preview_image}
                                    alt="Preview"
                                />
                            )}
                            {user.name}
                            <span className={"delete-user-badge"} onClick={(e) => {
                                e.stopPropagation();
                                if (onUnselect) {
                                    onUnselect(user,e)}
                                }
                            }>x</span>
                        </Badge>
                    ))}
                </>
            );
        }

        // Fallback, wenn keine Benutzer vorhanden sind
        return (
            <Badge
                className={"cursor-pointer"}
                ref={ref}
                onClick={(e) => {
                    e.preventDefault();
                    onClick(e);
                }}
                pill
                bg={"none"}
                text={"dark"}
                style={{ border: "1px dashed grey" }}
            >
                +
            </Badge>
        );
    });

    return (
        <td key={'au-'+rowData.id} className={`border px-4 py-2${className ? " " + className : ""}`}>
            {selectList && Object.entries(selectList).length > 0 && (
                <Dropdown show={menuOpen} key={'d-'+rowData.id}
                          onToggle={(open) => {
                              onMenuChange(open);
                          }}
                          onSelect={(value) => {
                    onSelect(value);
                    onMenuChange(false);
                    setSelectMode(false);
                }}>
                    <Dropdown.Toggle key={'dt-'+rowData.id} as={UserPillElement} users={selectedUsers}
                                     onUnselect={onUnSelect}
                                     id="dropdown-select-user">
                        Custom toggle
                    </Dropdown.Toggle>
                    <Dropdown.Menu>

                        {rowData.assigned_user_id &&
                            <Dropdown.Item eventKey={null} key={null}>
                                <Badge  pill
                                                            bg={"none"}
                                                            text={"dark"}
                                                            style={{border: "1px dashed grey"}}
                        >
                            -
                        </Badge>
                        </Dropdown.Item>}
                        {Object.entries(selectList)
                            // Deaktivierte Benutzer nicht neu zuweisbar machen (aber weiter als Pill anzeigen).
                            .filter(([, value]) => value.is_active !== false && value.is_active !== 0)
                            .map(([key, value]) => {
                                return (
                                    <Dropdown.Item eventKey={key} key={key}>
                                        <Badge pill bg={"none"} style={{backgroundColor: value.color ?? 'grey'}}>
                                            {value.preview_image &&
                                                <img className={'pill-user-image'} src={value.preview_image}
                                                     alt="Preview"/>}
                                            {value.name}
                                        </Badge>
                                    </Dropdown.Item>
                                )
                            }
                        )
                        }
                    </Dropdown.Menu>
                </Dropdown>
            )}
        </td>
    );

}
